// extracted by mini-css-extract-plugin
export default {"root":"Card_root__QcB8b","overlapCardRoot":"Card_overlapCardRoot__TlRB5"};